import {MeshBounds} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshBounds';
import {MeshCellNote} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellNote';
import {observable} from 'mobx';

export class MeshNoteState
{
    public noteTitleRef:HTMLElement = null;
    public noteTextRef:HTMLElement = null;

    @observable public activeCellBounds:MeshBounds = MeshBounds.from(0, 0, 0, 0);
    @observable public colIndex:number = null;
    @observable public rowIndex:number = null;

    @observable public note:MeshCellNote = null;
}
